import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import MaintenancePlanLayer from "../components/MaintenancePlanLayer";

const MaintenancePlanPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle="Task Templates">

        {/* MaintenancePlanLayer */}
        <MaintenancePlanLayer />
      </MasterLayout>
    </>
  );
};

export default MaintenancePlanPage;